<template>
  <div class="bcc-radio-group" role="group">
    <slot></slot>
  </div>
</template>
<script>
export default {
  name: 'BccRadioGroup',
  componentName: 'BccRadioGroup',
  props: {
    value: [String, Number, Boolean],
    disabled: {
      type: Boolean,
      default: false
    }
  }
}
</script>
